// extracted by mini-css-extract-plugin
module.exports = {"rect":"ORlEEgvN","text":"ebSI0Ilc","groupSelected":"sW9fRLDA"};